import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { ScheduledRoundsApiService } from 'src/app/core/api/scheduled-rounds/scheduled-rounds-api.service';

@Injectable({
  providedIn: 'root',
})
export class ScheduledRoundEditGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly scheduledRoundsApi = inject(ScheduledRoundsApiService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const roundId = route.paramMap.get('id');

    if (!roundId) {
      return of(this.router.parseUrl('/scheduled-rounds'));
    }

    return this.scheduledRoundsApi.getScheduledRound(roundId).pipe(
      map(round => {
        if (round.status === 'Completed' || !round.can_edit) {
          return this.router.parseUrl('/scheduled-rounds');
        }

        return true;
      }),
      catchError((error: HttpErrorResponse) =>
        of(this.router.parseUrl(error.status === 404 ? '/not-found' : '/scheduled-rounds'))
      )
    );
  }
}
